import React from "react";

module.exports = React.createClass({

    getDefaultProps() {
        return {
            saMode: false
        };
    },

    successLogin: function (reply) {
        HC_SetLoginSettings(reply);

        HC_RestoreNavPanel();
        if (HC_CheckSubscription()) {
            HC_History.replace('/due');
            HC_CloseModal();
        }
    },

    errorLogin: function (code, errorString) {
        HC_SetError(code, errorString);
        this.OnBackClicked();
    },

    successRequest: function () {
        HC_ShowMessage("User has been created!");
        if (this.props.saMode) {
            const user = {country: '', timezone: null};
            document.getElementById('hc-signup-pass2').value = '';
            return this.setState({newUser: user});
        }
        const payload = {
            login: this.state.newUser.email,
            password: this.state.newUser.password,
            is_free: window.HC_SITE_LOGO.isFree
        };
        HC_SendRequest("login", payload, this.successLogin, this.errorLogin);
    },

    errorRequest: function (code, errorString) {
        if (code == 409) {
            if (errorString.length > 0) {
                if (errorString.indexOf("DUPLICATED_COMPANY_NAME") >=0)
                    this.state.existingCompanies[errorString.slice(errorString.indexOf("DUPLICATED_COMPANY_NAME") + 24).toLowerCase()] = true;
                else if (errorString.indexOf("DUPLICATED_EMAIL") >= 0)
                    this.state.existingUsers[errorString.slice(errorString.indexOf("DUPLICATED_EMAIL") + 17).toLowerCase()] = true;
                HC_Validate();
            }
        }
        else
            HC_SetError(code, errorString);
    },

    getInitialState: function() {
        HC_InitReCaptcha();
        return {
            needGoBack: false,
            newUser: {country:""},
            countries: [{id: -1, title: ''}],
            companyTypes: [{id: "", title: HC_LANG.SU_CHOOSE}, // this string is used in validation!!!
                {id: 0, title: HC_LANG.SU_COMP_TYPE1},
                {id: 1, title: HC_LANG.SU_COMP_TYPE2},
                {id: 5, title: HC_LANG.SU_COMP_TYPE3},
                {id: 2, title: HC_LANG.SU_COMP_TYPE4},
                {id: 3, title: HC_LANG.SU_COMP_TYPE5},
                {id: 4, title: HC_LANG.CHL_OTHER.substring(0, 1).toUpperCase() + HC_LANG.CHL_OTHER.substring(1)}],
            existingCompanies:{},
            existingUsers:{},
            afterFailState: false,
            isLicenseArgee: false
        };
    },

    componentDidUpdate: function() {
        $('option[value=""]').attr("disabled", "disabled");
    },


    newUserTextFieldChanged(o) {
        HC_Validate(o.target, !this.state.afterFailState);
        this.state.newUser[o.target.getAttribute('name')] = o.target.value;
        this.setState({newUser: this.state.newUser});
    },


    handleSignupClick: function (o) {
        if (HC_Validate()) {
             // TODO There is no way to use recaptcha in Phonegap
            const payload = this.state.newUser;
            payload.captcha = this.props.saMode || window.cordova ? "mycaptcha" : grecaptcha.getResponse();
            payload.tz_offset = -60 * this.state.newUser.timezone;
            payload.is_paid_user = this.props.saMode;
            HC_SendRequest("signup", payload, this.successRequest, this.errorRequest);
        }
        else
            this.state.afterFailState = true;
    },

    ensureGlobalValidationFunctionsCreated: function (o) {
        if (window.HC_SIGNUP_VALIDATION != this) {
            window.HC_SIGNUP_VALIDATION = this;

            window.HC_SignupValidation_CompanyName = function(str) {
                if (typeof str === 'string' && str.length > 0) {
                    if (this.state.existingCompanies[str.toLowerCase()])
                        return [false, HC_LANG.SU_COMP_EXIST];
                    return [true, ""];
                }
                return [false, HC_LANG.SU_FIELD_DONT_EMPTY];
            }.bind(this);

            window.HC_SignupValidation_Email = function(str) {
                var r = HC_ValidateEmail(str);
                if (r[0]) {
                    if (this.state.existingUsers[str.toLowerCase()])
                        return [false, HC_LANG.SU_USER_EMAIL_EXIST];
                    return [true, ""];
                }
                return r;
            }.bind(this);

            window.HC_SignupValidation_Select = function (str) {
                return (str !== HC_LANG.SU_CHOOSE ? [true, ""] : [false, HC_LANG.SU_FIELD_DONT_EMPTY])
            };
            window.HC_SignupValidation_Passwords = function (str) {
                return ($('#hc-signup-pass1').val() === $('#hc-signup-pass2').val() ? [true, ""] : [false, HC_LANG.ADM_PASS_NOTMATCH])
            };
        }
    },

    licenseClicked: function() {
        let isChecked =  $('#hc-license').is(':checked');
        this.setState({isLicenseArgee: isChecked})
    },
    readLicenseClicked: function () {
        const win = window.open('/license', '_blank');
        win.focus();
    },


    render: function() {
        this.ensureGlobalValidationFunctionsCreated();
        const isSAMode = this.props.saMode;
        var i = 0;
        var countries = this.getCountries().map(function (o) {
            ++i;
            return (<option key={i} value={o}>{o}</option>);
            });
        var companies = this.state.companyTypes.map(function (s) {
            return (<option key={s.id} value={s.title}>{s.title}</option>);
        });

        var rowLabelStyle = {margin: "0 0 0.5% !important", padding: "0.2% ", flexFlow: "row wrap"};
        var captionDivStyle = {textAlign:"left !important", display: "inline-block ", marginRight:"2% ", width:"40% ",overflow:"hidden ", textOverflow:"ellipsis ", whiteSpace:"nowrap ", paddingTop:"0.3rem" };
        var inputDivStyle = {display: "inline-block ", width: "100% ", flex: "1 1 150px"};
        var inputStyle100 = {width: "100% ", display: "inline "};
        var errorDivStyle = {display: 'none'};

        let licenseChkStyle = {verticalAlign: "sub", margin: "10px", width: "22px", height: "22px"};
        let signBtnClass = "hc-button";
        let opts = {};
        if (!this.state.isLicenseArgee && !isSAMode) {
            signBtnClass += ' hc-button-off';
            opts['disabled'] = 'disabled';
        }        

        return(
            <div className="form-horizontal" style={{display:"block", marginTop:"0em"}}>

                <div className="container"
                     style={{height:"100%", width: (HC_DeviceType() == HC_CONST.SCR_TABLET) ? "80%" : "100%", textAlign:"left", padding:"0 5% 5% 5%" }}>

                    <input style={{display:"inline", borderColor:"transparent", width:"0rem", height:"0px"}} value=""/>
                    <input type="password"
                           style={{display:"inline", borderColor:"transparent", width:"0rem", height:"0px"}}/>

                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-compname" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_CO_NAME}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input id="hc-signup-compname-input" className="form-control hc-f4 hc-validated" style={inputStyle100}
                                   name="company_name" value={this.state.newUser.company_name} onChange={this.newUserTextFieldChanged}
                                   data-vfunc="HC_SignupValidation_CompanyName" data-vtext="hc-signup-name-error" data-vcaption="hc-signup-compname"
                            />
                            <div id="hc-signup-name-error" style={errorDivStyle}/>
                        </div>
                    </div>

                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-comptype-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_CO_TYPE}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <select className="form-control hc-f4 hc-validated" style={inputStyle100} name="company_type"
                                    value={this.state.newUser.company_type} onChange={this.newUserTextFieldChanged}
                                    data-vfunc="HC_SignupValidation_Select" data-vtext="hc-signup-comptype-error" data-vcaption="hc-signup-comptype-caption">
                                {companies}
                            </select>
                            <div id="hc-signup-comptype-error" style={errorDivStyle}/>
                        </div>
                    </div>

                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-address-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_CO_ADR}
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input className="form-control hc-f4" style={inputStyle100} name="address" value={this.state.newUser.address} onChange={this.newUserTextFieldChanged}/>
                        </div>
                    </div>
                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-phone-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_PHONE || "Phone"}
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input className="form-control hc-f4" style={inputStyle100} name="phone" value={this.state.newUser.phone} onChange={this.newUserTextFieldChanged}/>
                        </div>
                    </div>
                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-zip-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_ZIP}
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input className="form-control hc-f4" style={inputStyle100} name="zip_code" value={this.state.newUser.zip_code} onChange={this.newUserTextFieldChanged}/>
                        </div>
                    </div>
                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-city-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_CITY}
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input className="form-control hc-f4" style={inputStyle100} name="city" city value={this.state.newUser.city} onChange={this.newUserTextFieldChanged}/>
                        </div>
                    </div>
                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-country-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_COUNTRY}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <select className="form-control hc-f4 hc-validated" style={inputStyle100} name="country" value={this.state.newUser.country} onChange={this.newUserTextFieldChanged}
                                    data-vfunc="HC_SignupValidation_Select" data-vtext="hc-signup-country-error" data-vcaption="hc-signup-country-caption">
                                <option key="0" value={null}>{HC_LANG.SU_CHOOSE}</option>
                                {countries}
                            </select>
                            <div id="hc-signup-country-error" style={errorDivStyle}/>
                        </div>
                    </div>

                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-timezone-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.PRO_TIMEZONE}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <select className="form-control hc-f4 hc-validated" style={inputStyle100} name="timezone" value={this.state.newUser.timezone} onChange={this.newUserTextFieldChanged}
                                    data-vfunc="HC_SignupValidation_Select" data-vtext="hc-signup-timezone-error" data-vcaption="hc-signup-timezone-caption">
                                <option value={null}>{HC_LANG.SU_CHOOSE}</option>
                                <option value="-12">UTC-12</option>
                                <option value="-11">UTC-11</option>
                                <option value="-10">UTC-10</option>
                                <option value="-9">UTC-9</option>
                                <option value="-8">UTC-8</option>
                                <option value="-7">UTC-7</option>
                                <option value="-6">UTC-6</option>
                                <option value="-5">UTC-5</option>
                                <option value="-4">UTC-4</option>
                                <option value="-3">UTC-3</option>
                                <option value="-2">UTC-2</option>
                                <option value="-1">UTC-1</option>
                                <option value="0">UTC</option>
                                <option value="1">UTC+1</option>
                                <option value="2">UTC+2</option>
                                <option value="3">UTC+3</option>
                                <option value="4">UTC+4</option>
                                <option value="5">UTC+5</option>
                                <option value="6">UTC+6</option>
                                <option value="7">UTC+7</option>
                                <option value="8">UTC+8</option>
                                <option value="9">UTC+9</option>
                                <option value="10">UTC+10</option>
                                <option value="11">UTC+11</option>
                                <option value="12">UTC+12</option>
                            </select>
                            <div id="hc-signup-timezone-error" style={errorDivStyle}/>
                        </div>
                    </div>


                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div className="hc-f3" style={{color:"#5f6876", maxWidth: "95%", whiteSpace: 'normal'}}>{HC_LANG.SU_TEXT}</div>
                    </div>

                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-fname-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_FNAME}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input className="form-control hc-f4 hc-validated" style={inputStyle100} name="first_name" value={this.state.newUser.first_name} onChange={this.newUserTextFieldChanged}
                                   data-vfunc="HC_ValidateNotEmptyField" data-vtext="hc-signup-fname-error" data-vcaption="hc-signup-fname-caption"/>
                            <div id="hc-signup-fname-error" style={errorDivStyle}/>
                        </div>
                    </div>
                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-lname-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_LNAME}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input className="form-control hc-f4 hc-validated" style={inputStyle100} name="last_name" value={this.state.newUser.last_name} onChange={this.newUserTextFieldChanged}
                                   data-vfunc="HC_ValidateNotEmptyField" data-vtext="hc-signup-lname-error" data-vcaption="hc-signup-lname-caption"/>
                            <div id="hc-signup-lname-error" style={errorDivStyle}/>
                        </div>
                    </div>

                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-email-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.ADM_EMAIL + ": "}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input className="form-control hc-f4 hc-validated" type="email" style={inputStyle100} name="email" value={this.state.newUser.email} onChange={this.newUserTextFieldChanged}
                                   data-vfunc="HC_SignupValidation_Email" data-vtext="hc-signup-email-error"
                                   data-vcaption="hc-signup-email-caption" autoComplete="off"/>
                            <div id="hc-signup-email-error" style={errorDivStyle}/>
                        </div>
                    </div>
                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-pass1-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_CREATE_PASS}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input id="hc-signup-pass1" className="form-control hc-f4 hc-validated" style={inputStyle100} name="password"
                                   value={this.state.newUser.password} onChange={this.newUserTextFieldChanged}
                                   type="password" autoComplete="off"
                                   data-vfunc="HC_ValidatePassword" data-vtext="hc-signup-pass1-error" data-vcaption="hc-signup-pass1-caption"/>
                            <div id="hc-signup-pass1-error" style={errorDivStyle}/>
                        </div>
                    </div>
                    <div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div id="hc-signup-pass2-caption" style={captionDivStyle}
                             className="control-label hc-f4 hc-f-l2">{HC_LANG.SU_REP_PASS}*
                        </div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <input id="hc-signup-pass2" className="form-control hc-f4 hc-validated" style={inputStyle100} name="confirm"
                                   onChange={this.newUserTextFieldChanged} type="password"
                                   data-vfunc="HC_SignupValidation_Passwords" data-vtext="hc-signup-pass2-error" data-vcaption="hc-signup-pass2-caption"/>
                            <div id="hc-signup-pass2-error" style={errorDivStyle}/>
                        </div>
                    </div>

                    {!isSAMode && (<div className="form-group hc-flex-display" style={rowLabelStyle}>
                        <div className="hc-f4 hc-f-l2" style={{margin: "auto"}}>
                            <input id="hc-license" className="hc-f4" style={licenseChkStyle} type="checkbox" onChange={this.licenseClicked} />
                            {HC_LANG.SU_LICENSE_IAGR || "I agree to the "}
                            <span className="hc-green hc-text-with-cursor" onClick={this.readLicenseClicked}>{HC_LANG.SU_LICENSE_TERM || " Terms of Service"}</span>
                        </div>
                    </div>)}

                    {!isSAMode && !window.cordova && (<div className="g-recaptcha hc-validated" data-sitekey="6Lc0-gkUAAAAAEXhX7zT3so2-zWpERmwdU8b8Iko" data-vfunc="HC_ValidateCaptcha"></div>)}

                    <div className="form-actions hc-flex-display" style={$.merge({marginTop:'2rem'}, rowLabelStyle)}>
                        <div style={captionDivStyle} className="control-label hc-f-l"></div>
                        <div className="hc-flex-signup" style={inputDivStyle}>
                            <span>
                                <button className={signBtnClass} 
                                    style={{marginRight:"0.5rem"}} {...opts}
                                    onClick={this.handleSignupClick}>
                                    {isSAMode ? 'Register' : HC_LANG.INDEX_SIGNUP_BUTTON}
                                </button>
                                {!isSAMode && <button className="hc-button-cancel hc-f-l" 
                                    style={{marginRight:"4%"}}
                                    onClick={this.props.OnBackClicked}>
                                    {HC_LANG.DUE_CANCEL}
                                </button>}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    },

    getCountries: function() {
      if (!window.HC_COUNTRIES)
          window.HC_COUNTRIES = ["Afghanistan", "Albania","Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire,Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Côte d`Ivoire", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Congo,Democratic Republic", "Cook Islands", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Korea", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn Islands", "Poland", "Portugal", "Puerto Rico", "Qatar", "Réunion", "Romania", "Russia", "Rwanda", "São Tomé and Príncipe", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "US Virgin Islands", "USA", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican", "Venezuela", "Vietnam", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];
        return window.HC_COUNTRIES;
    }
});


// WEBPACK FOOTER //
// ./signup.js